import React from "react";
import { Box, Button, Grid } from "@mui/material";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../../styles/muiProps";
import InputGroupShape from "../../../../../../../../components/Inputs/InputGroupShape";

export default function PadPanel() {
  const table = useMaterialReactTable({
    ...lightTable,
    data: [
      // { c: "*" }
    ],
    columns: [
      {
        accessorKey: "c",
        header: "c",
        size: 10,
      },

      {
        accessorKey: "Component",
        header: "Component",
        size: 10,
      },
      {
        accessorKey: "Pad OD",
        header: "Size",
        size: 10,
      },
      {
        accessorKey: "Schedule",
        header: "Schedule",
        size: 10,
      },
      {
        accessorKey: "Thickness",
        header: "Thickness",
        size: 10,
      },

      {
        accessorKey: "Material",
        header: "Material",
        size: 10,
      },
      {
        accessorKey: "Requirements",
        header: "Requirements",
        size: 10,
      },
      {
        accessorKey: "Material Code",
        header: "Material Code",
        size: 10,
      },
      {
        accessorKey: "Material Description",
        header: "Material Description",
        size: 10,
      },
      {
        accessorKey: "Family Table",
        header: "Family Table",
        size: 10,
      },
    ],
  });

  return (
    <>
      <Grid container>
        <Grid item xs={8} sx={{ pt: 2 }}>
          <InputGroupShape name="Nozzles Details">
            <MaterialReactTable table={table} />
          </InputGroupShape>
        </Grid>
      </Grid>

      <Box sx={{ p: 1 }}>
        <Button sx={{ mr: 1 }} variant="contained">
          Obtain
        </Button>
        <Button sx={{ mr: 1 }} variant="outlined">
          Update Family
        </Button>
        <Button sx={{ mr: 1 }} variant="outlined">
          Update Part
        </Button>
      </Box>
    </>
  );
}
